import { RouteConfig } from 'vue-router'

export const hierarchyRoutes: Array<RouteConfig> = [
  {
    path: '/hierarchy-setup',
    name: 'Compensation Setup',
    component: () => import('@/modules/hierarchySetup/views/HierarchySetupPage.vue')
  }
]
